import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as shortlistActions from '../../actions/shortlist';
import FilterSelect from '../../components/FilterSelect';
import { isCommonFilterDisabled } from '../../helpers/catalogueUtils';
import { shortlistStateKey } from '../../helpers/shortlistUtils';

class SaleFilters extends PureComponent {
    static propTypes = {
        refinement: PropTypes.shape({
            saleName: PropTypes.string
        }).isRequired,
        data: PropTypes.shape({
            saleNameOptions: PropTypes.array.isRequired
        }).isRequired,
        loadSaleNameOptions: PropTypes.func.isRequired,
        applyShortlistSaleNameFilter: PropTypes.func.isRequired
    };

    isCommonFilterDisabled() {
        return isCommonFilterDisabled(this.props.refinement);
    }

    handleSaleNameChange = (event) => {
        this.props.applyShortlistSaleNameFilter(event.target.value);
    };

    render() {
        const {
            refinement: {
                saleName
            },
            data: {
                saleNameOptions
            },
            loadSaleNameOptions,
            applyShortlistSaleNameFilter
        } = this.props;
        return (
            <div>
                <div className="sales__catalogueRefineOptionGrp">
                    <span>Sale Name</span>
                    <FilterSelect
                        title="Sale Name"
                        alphabet
                        showSearch
                        disabled={this.isCommonFilterDisabled()}
                        value={saleName}
                        options={saleNameOptions}
                        onPopoverDidOpen={loadSaleNameOptions}
                        onChange={applyShortlistSaleNameFilter}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { refinement, data } = state[shortlistStateKey];
    return {
        refinement,
        data
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(shortlistActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SaleFilters);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/SaleFiltersShortlist.js